import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AmpFooter from "../components/common/AmpFooter/AmpFooter";
import HeaderNav from "../components/common/HeaderNav/HeaderNav";
import LanguageAccessibilty from "../components/common/LanguageAccessibility/LanguageAccessibilty";
import Logo from "../components/common/Logo/Logo";
import { useNavigate } from "react-router-dom";

import "./PierPortal.css";
import { useDispatch, useSelector } from "react-redux";
import { getPierMessage } from "../redux/actions/pierMessage/pierMessage";
import { RootState } from "../redux/reducers/root";
import { pierMessageState } from "../redux/reducers/getPierMessageReducer/pierMessageReducer";
import ReactGA from "react-ga4";

export default function PierPortal(): JSX.Element {

    const { t } = useTranslation("landing");
    const storageTip = localStorage.getItem("amptip");
    const storageLang = localStorage.getItem("prefLang");
    const pierMessage = useSelector((state: RootState) => state.pierLinkTextReducer.pierMessage as pierMessageState);
    const [hasPierMessage, setHasPierMessage] = useState((pierMessage.message_en && pierMessage.message_fr) ? true : false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const enabled = pierMessage.enabled === 1 ? true : false;

    useEffect(() => {
        if (!hasPierMessage) {
            dispatch(getPierMessage());
        }        
    }, [dispatch, hasPierMessage]);

    useEffect(() => {
        if (!pierMessage.loading) {
            if (pierMessage.message_en || pierMessage.message_fr){
                setHasPierMessage(true);
            }
            else {
                setHasPierMessage(false);
            }
        }
    }, [pierMessage]);

    const toAmp = () => {
        localStorage.removeItem("ampSplash");
        navigate("/amp");
    }

    return (
        <>
            <div className="pier-portal-body">
                <div className="logo-header">
                    <div className="logo-image"><Logo /></div>
                    <div className="language-accessibility-container"><LanguageAccessibilty /></div>                
                </div>
                <div className="second-header">
                    <HeaderNav isAuthed={true} pierSplash={true}></HeaderNav>
                </div>
            </div>
            <div className="fake-blue-nav"/>
            <div className="image-container">
                <img className="splashPageBg" src="" alt=""></img>
            </div>
            <div className="pier-portal-body">
                <div className="pier-portal-caption">
                    <h1>{t("landing.pier-select")}</h1>
                </div>
                <div className="pier-portal-container">
                    <div className="portal-container first-container">
                        <div className="logo-image"><Logo /></div>
                        <p><button onClick={() => {toAmp()}}>{t("pier-portal.amp-link")}</button><sup>TM</sup> <br/> {t("pier-portal.amp-text")}</p>
                    </div>
                    <div className="pier-portal-or">
                        <h1>or</h1>
                    </div>
                    <div className="portal-container second-container">
                        <h1>{t("pier-portal.pier-title")}</h1>
                        {enabled ? 
                        <a href={`${process.env.REACT_APP_PIER_UI}${storageTip}?lang=${storageLang}`} onClick={((e) => {
                            ReactGA.event({
                                category: "Login/Registration",
                                action: "PIER Navigation",
                                label: `${storageTip} PIER Navigation`, // optional
                            });
                        })}>
                            {hasPierMessage ? ((storageLang === "fr" || storageLang === "fr_FR") ? pierMessage.message_fr : pierMessage.message_en) : t("pier-portal.pier-placeholder-link-text") as string}
                        </a> 
                        : 
                        <p>
                            {hasPierMessage ? ((storageLang === "fr" || storageLang === "fr_FR") ? pierMessage.message_fr : pierMessage.message_en) : t("pier-portal.pier-placeholder-link-text") as string}
                        </p>
                        }

                    </div>
                </div>
            </div>
            <div className="pier-portal-footer">
                <AmpFooter/>
            </div>
        </>
    )
}